import { themes } from '@lokalise/louis';

import generateThemeColors from '../customColor';
import { palette } from '../customPalette';
import customTypography from '../customTypography';
import zIndices from '../zIndices/zIndices.json'; // eslint-disable-line import/extensions

export const breakpoints = {
    sm: '768px',
    md: '992px',
    lg: '1200px',
    xlg: '1500px',
    xxlg: '1800px',
};

export const boxShadow = {
    1: '0px 0px 5px rgba(0, 0, 0, 0.2)',
    2: '0px 0px 12px rgba(0, 0, 0, 0.2)',
};

export const typographyExtends = {
    primaryButton: {
        fontSize: '12px',
        lineHeight: '17px',
        fontWeight: 500,
    },
    primaryButton2: {
        fontSize: '12px',
        lineHeight: '14px',
        fontWeight: 500,
    },
};

const customColor = generateThemeColors(palette, 'light');

export default {
    ...themes.light,
    typography: {
        ...themes.light.typography,
        custom: {
            ...customTypography,
            ...typographyExtends,
        },
    },
    color: {
        ...themes.light.color,
        custom: customColor,
    },
    zIndex: zIndices,
    breakpoints,
    boxShadow,
};
